if (document.getElementById('register-app')) {

    var appNovoAnuncie = new Vue({
        el: '#register-app',
        data: {
            objForm: {
                loginSocial: false,
                google_id: '',
                facebook_id: '',
                nome: '',
                email: ''
            },
            cadastroPorLoginSocial: false,
            autenticacaoPorFacebook: false,
            autenticacaoPorGoogle: false,
            emailVeioAtravesDaAutenticacaoSocial: false
        },
        methods: {
            renderGoogleLoginButton: function()
            {
                let _this = this;

                setTimeout(function() {
                    gapi.load('auth2', function() {
                        let auth2 = gapi.auth2.getAuthInstance();

                        gapi.signin2.render('btn-google-auth', {
                            width: 369,
                            height: 40,
                            onsuccess: function(user)
                            {
                                if (_this.autenticacaoPorFacebook == false) {
                                    let profile = auth2.currentUser.get().getBasicProfile();
                                    let idToken = user.getAuthResponse().id_token;
    
                                    axios.post(
                                        '/api/anunciantes/login-social',
                                        { token: idToken, type: 'google' }
                                    ).then(function(response) {
                                        if (response.data.data.possui_cadastro_por_login_social == false) {
                                            _this.objForm.loginSocial = true;
                                            _this.autenticacaoPorGoogle = true;
                                            _this.objForm.google_id = profile.getId();
                                            _this.objForm.facebook_id = '';
                                            _this.cadastroPorLoginSocial = true;

                                            localStorage.setItem('login_social_media', true);
                                            localStorage.setItem('nome', profile.getName());
                                            localStorage.setItem('email', profile.getEmail());
                                            localStorage.setItem('google_id', profile.getId());
                                            localStorage.setItem('facebook_id', '');
    
                                            if (profile.getName()) {
                                                $('#nome').val(profile.getName());
                                            }
        
                                            if (profile.getEmail() && profile.getEmail() != 'undefined') {
                                                $('#email').val(profile.getEmail());
                                                _this.emailVeioAtravesDaAutenticacaoSocial = true;
                                            }
                                        } else if (response.data.data.possui_cadastro_por_login_social == true) {
                                            window.location.href = '/';
                                        }
                                    });
                                } else {
                                    _this.logoutGoogleSemResetarCadastro();
                                }                        
                            },
                            onerror: function(error)
                            {
                            }
                        });
                    });
                }, 1500);
            },
            logoutGoogle: function()
            {
                let _this = this;
                var auth2 = gapi.auth2.getAuthInstance();

                auth2.signOut().then(function () {
                  _this.autenticacaoPorGoogle = false;
                  _this.resetarCadastroPorLoginSocial();
                });
            },
            logoutGoogleSemResetarCadastro: function()
            {
                let _this = this;
                var auth2 = gapi.auth2.getAuthInstance();

                auth2.signOut().then(function () {
                    _this.autenticacaoPorGoogle = false;
                    _this.objForm.google_id = '';
                    localStorage.setItem('google_id', '');
                });
            },
            callBackFacebookLogado: function(facebookResponse)
            {
                let _this = this;
                let _responseFacebook = facebookResponse;

                if (facebookResponse.status == 'connected') {
                    axios.post(
                        '/api/anunciantes/login-social',
                        { token: facebookResponse.authResponse.accessToken, type: 'facebook' }
                    ).then(function(response) {
                        if (response.data.data.possui_cadastro_por_login_social == false) {
                            if (typeof FB !== 'undefined') {
                                FB.api('/me?fields=id,name,email', function(facebookRes) {
                                    _this.cadastroPorLoginSocial = true;
                                    _this.autenticacaoPorFacebook = true;
                                    _this.objForm.loginSocial = true;
                                    _this.objForm.facebook_id = _responseFacebook.authResponse.userID;
                                    _this.objForm.google_id = '';
                                    localStorage.setItem('login_social_media', true);
                                    localStorage.setItem('nome', facebookRes.name);
                                    localStorage.setItem('email', facebookRes.email);
                                    localStorage.setItem('facebook_id', _responseFacebook.authResponse.userID);
                                    localStorage.setItem('google_id', '');

                                    if (facebookRes.name) {
                                        $('#nome').val(facebookRes.name);
                                    }

                                    if (facebookRes.email && facebookRes.email != 'undefined') {
                                        $('#email').val(facebookRes.email);
                                        _this.emailVeioAtravesDaAutenticacaoSocial = true;
                                    }

                                });
                            }
                        } else if (response.data.data.possui_cadastro_por_login_social == true) {
                            window.location.href = '/';
                        }
                    })
                }
            },
            logarComFacebook: function()
            {
                let _this = this;
                if (typeof FB !== 'undefined') {
                    FB.login(function(response) {
                        if (response.authResponse) {
                            _this.callBackFacebookLogado(response);
                        }
                    }, {scope: 'public_profile, email'});
                }
            },
            logoutFacebook: function(response)
            {
                _this = this;

                if (typeof FB !== 'undefined') {
                    FB.getLoginStatus(function(response) {
                        if (response.status === 'connected') {                        
                            FB.logout(function() {
                                _this.autenticacaoPorFacebook = false;
                                _this.resetarCadastroPorLoginSocial();
                            });
                        }
                    });    
                }           
            },
            resetarCadastroPorLoginSocial: function()
            {
                this.cadastroPorLoginSocial = false;
                this.objForm.loginSocial = false;
                this.objForm.facebook_id = '';
                this.objForm.google_id = '';
                this.objForm.nome = '';
                this.objForm.email = '';
                this.emailVeioAtravesDaAutenticacaoSocial = false;

                localStorage.setItem('login_social_media', false);
                localStorage.setItem('nome', '');
                localStorage.setItem('email', '');
                localStorage.setItem('facebook_id', '');
                localStorage.setItem('google_id', '');
            },
            verificarSeFacebookEstaLogado: function()
            {
                let _this = this;

                if (typeof FB !== 'undefined') {
                    FB.getLoginStatus(function (response) {
                        if (response.status == 'connected') {
                            _this.callBackFacebookLogado(response);
                        }
                    });
                }
            },
            verificarRedundanciaAutenticacaoSocial: function()
            {
                _this = this;

                setInterval(function() {
                    if (_this.autenticacaoPorFacebook == true && _this.autenticacaoPorGoogle == true) {
                        _this.logoutGoogleSemResetarForm();
                    }
                }, 700);
            },
            logoutGoogleSemResetarForm: function()
            {
                let _this = this;
    
                var auth2 = gapi.auth2.getAuthInstance();
                
                auth2.signOut().then(function () {
                    _this.autenticacaoPorGoogle = false;
                    _this.objForm.google_id = '' ;
                    _this.objForm.google_token = '';
                    localStorage.setItem('google_id', '');
                });
            },
            enviar: function ()
            {
                $('#email').removeAttr("disabled");
            }
        },
        mounted () {
            this.verificarRedundanciaAutenticacaoSocial();
            this.verificarSeFacebookEstaLogado();
            this.renderGoogleLoginButton();
            window.facebookLoginUsuario = this.facebookLoginUsuario;
            let localStorage = window.localStorage;

            if (localStorage.getItem('login_social_media') == 'true') {
                this.objForm.loginSocial = true;
                this.objForm.google_id = localStorage.getItem('google_id');
                this.objForm.facebook_id = localStorage.getItem('facebook_id');
            }
        }
    });

    $(document).ready(function(){
        let localStorage = window.localStorage;
        
        if (localStorage.getItem('nome') && $('#nome').val() == '') {
            $('#nome').val(localStorage.getItem('nome'));
        }

        if (localStorage.getItem('email') && $('#email').val() == '') {
            if (localStorage.getItem('email') != 'undefined') {
                $('#email').val(localStorage.getItem('email'));
            }
        }
    });
}
